/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as angular from 'angular';

import * as ngAnimate from 'angular-animate';
import * as ngSanitize from 'angular-sanitize';
import * as ngClipboard from 'ngclipboard';
//TEMP, come up with new solution. Ie... do this shit somewhere else
import './dev-settings';

angular.module('ticketspaceApp.controllers', []); //"ngAnimate"
angular.module('CanvasWrapper', []); // Module which contains Canvas renderer wrappers
angular.module('ProjectView', ['CanvasWrapper']); // Module which contains all project view functionality

//define things here for now
angular.module('ticketspaceApp.directives', []);
let mod = angular.module('ticketspaceApp', [
	'$$UpgradeModule',
	'firebase',
	ngSanitize,
	ngAnimate,
	'fbdbApi',
	'ticketspaceApp.controllers', // ticketspace-controllers.js
	'ticketspaceApp.directives', // ticketspace-directives.js
	'ticketspaceApp.filters',
	'ticketspaceApp.dev-settings',
	'ProjectView',
	ngClipboard,
]);

// const appModule:string = mod.name;
export default mod;
